/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { initialize } from "../../actions";
import { DEREGISTER_FOR_OPEN_HOUSE } from "../../graphql/deregisterForOH";
import { REGISTER_FOR_OPEN_HOUSE } from "../../graphql/registerForOH";

const registerForOH = createAsyncThunk(
  "openHouses/registerForOH",
  async (openHouseId, { extra }) => {
    const { analyticsService, graphqlMutationService } = extra;

    return graphqlMutationService
      .mutate({
        mutation: REGISTER_FOR_OPEN_HOUSE,
        variables: { open_house_id: openHouseId }
      })
      .then(({ data }) => {
        if (data.register_for_open_house.successful) {
          analyticsService.sendSaveOpenHouseEvent({ openHouseId });
          return openHouseId;
        }
        return null;
      });
  }
);

const deregisterForOH = createAsyncThunk(
  "openHouses/deregisterForOH",
  async (openHouseId, { extra }) => {
    const { analyticsService, graphqlMutationService } = extra;

    return graphqlMutationService
      .mutate({
        mutation: DEREGISTER_FOR_OPEN_HOUSE,
        variables: { open_house_id: openHouseId }
      })
      .then(({ data }) => {
        if (data.deregister_for_open_house.successful) {
          analyticsService.sendUnsaveOpenHouseEvent({ openHouseId });
          return openHouseId;
        }
        return null;
      });
  }
);

const initRegisteredOH = open_houses => {
  const registeredOH = open_houses.filter(oh => oh.user_is_registered);
  return registeredOH.map(item => item.open_house_id);
};

const addMemberOnRegister = (open_houses, action, toAdd) => {
  const index = open_houses.map(item => item.open_house_id).indexOf(action);
  const newArray = open_houses.filter(item => item.open_house_id !== action);
  const newElement = open_houses.find(item => item.open_house_id === action);
  if (toAdd) {
    newElement.number_of_registered_users += 1;
  } else {
    newElement.number_of_registered_users -= 1;
  }
  newArray.splice(index, 0, newElement);
  return newArray;
};

const initialState = {
  openHouses: [],
  registeredOH: [],
  listingAddress: "",
  listingClass: "",
  listingId: null,
  listingLink: "",
  userIsPresent: false,
  featureFlags: []
};

const openHousesSlice = createSlice({
  name: "openHouses",
  initialState,
  reducers: {},
  extraReducers: {
    [initialize]: (state, action) => {
      const {
        feature_flags,
        listing_address,
        listing_class,
        listing_id,
        listing_link,
        open_houses,
        user_is_present
      } = action.payload;

      state.listingAddress = listing_address;
      state.listingClass = listing_class;
      state.listingLink = listing_link;
      state.listingId = listing_id;
      state.openHouses = open_houses;
      state.registeredOH = initRegisteredOH(open_houses);
      state.userIsPresent = user_is_present;
      state.featureFlags = feature_flags;
    },
    [registerForOH.fulfilled]: (state, action) => {
      state.registeredOH.push(action.payload);
      state.openHouses = addMemberOnRegister(
        state.openHouses,
        action.payload,
        true
      );
    },
    [deregisterForOH.fulfilled]: (state, action) => {
      state.registeredOH = state.registeredOH.filter(
        item => item !== action.payload
      );
      state.openHouses = addMemberOnRegister(
        state.openHouses,
        action.payload,
        false
      );
    }
  }
});

export default openHousesSlice.reducer;
export { registerForOH, deregisterForOH };
